// P2b-3 §1.2 tab-strip count helpers. Pure functions: take the master
// rows + lookup maps, return how many rows would land on each role
// grid. Counts are gate-only (filter-bar state ignored) so the tab
// header stays stable as users type in the filter — see spec answer Q1.
//
// Archived rollouts always count zero (the gate excludes them per
// §2.1 / §2.2). Caller passes that information explicitly so this stays
// pure and reusable from every rollout view.

import type { Account } from '../../types/account.js';
import type { AccountCampaign } from '../../types/accountCampaign.js';
import type { Campaign } from '../../types/campaign.js';
import type { FranchiseLocationProfile } from '../../types/franchiseLocationProfile.js';
import {
  passesGoogleGridFilter,
  passesMetaGridFilter,
} from '../../lib/passesPlatformGridFilter.js';

export type GridCounts = {
  meta: number;
  google: number;
};

export function computeGridCounts(args: {
  rows: AccountCampaign[];
  accountsById: Map<string, Account>;
  campaignsById: Map<string, Campaign>;
  locationProfilesById: Map<string, FranchiseLocationProfile>;
  rolloutArchived: boolean;
}): GridCounts {
  if (args.rolloutArchived) return { meta: 0, google: 0 };
  let meta = 0;
  let google = 0;
  for (const row of args.rows) {
    const acc = args.accountsById.get(row.accountId);
    if (!acc) continue;
    const profile = args.locationProfilesById.get(row.accountId) ?? null;
    const campaign = row.campaignId
      ? args.campaignsById.get(row.campaignId) ?? null
      : null;
    if (passesMetaGridFilter(row, acc, campaign, profile)) meta++;
    if (passesGoogleGridFilter(row, acc, campaign)) google++;
  }
  return { meta, google };
}
